import { Text, type TextProps, TextVariant } from '@vizit/atoms';
import * as React from 'react';
import { HeadingContext } from 'react-aria-components';

// The dialog owns the title's id, so callers can't pass their own.
function DialogTitle(props: Omit<TextProps, 'id'>) {
  // The dialog is named by the element carrying the id it hands its title slot, as react-aria's Heading would take
  // it; without the id the dialog has no accessible name. Read without useSlottedContext, which throws where a
  // HeadingContext has no title slot.
  const context = React.useContext(HeadingContext);
  const titleId = context && 'slots' in context ? context.slots?.title?.id : undefined;

  // The Text atom truncates to a single line by default, which cut dialog
  // titles off with an ellipsis whenever they exceeded the dialog width. A
  // dialog title must stay fully readable, so it wraps onto further lines
  // instead. Callers can still opt back into truncation via `showEllipsis`.
  return <Text variant={TextVariant.HeaderLg} elementType="h2" id={titleId} showEllipsis={false} {...props} />;
}

export { DialogTitle };
